module.exports = __webpack_public_path__ + "img/lg.8e08eded.png";